import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "fixed inset-0 flex px-6 py-2 pointer-events-none items-start z-50"
}
const _hoisted_2 = { class: "w-full flex flex-col items-center space-y-4 sm:items-end" }
const _hoisted_3 = {
  key: 0,
  class: "rounded-md bg-white border border-gray-200 max-w-md w-full shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
}
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_7 = {
  key: 1,
  class: "flex-shrink-0"
}
const _hoisted_8 = { class: "ml-3 w-0 flex-1" }
const _hoisted_9 = { class: "font-bold text-gray-900" }
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "ml-4 flex flex-shrink-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

import {
		ExclamationCircleIcon,
		CheckCircleIcon
	} from '@heroicons/vue/24/outline'

	// vue
	import {
		ref 
	} from 'vue'

	
	// name the component
	const __default__ = { name: "TwNotification" }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		duration: {
			type: Number,
			default: 5000
		},
		icon: {
			type: Number,
			default: 1,
		},
		title: {
			type: String,
			default: ""
		},
		subtitle: {
			type: String,
			default: ""
		}
	},
  emits: [
		'close'
	],
  setup(__props, { emit: __emit }) {

	// icons
	const props = __props

	const emit = __emit

	const show = ref(true)

	setTimeout(() => {
		close()
	}, props.duration)

	function close() {
		show.value = false
		emit('close')
	}

return (_ctx: any,_cache: any) => {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        "enter-active-class": "transform ease-out duration-300 transition",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition ease-in duration-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (show.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (__props.icon == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(CheckCircleIcon), {
                            class: "h-8 w-8 text-brand-500",
                            "aria-hidden": "true"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (__props.icon == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_unref(ExclamationCircleIcon), {
                            class: "h-8 w-8 text-red-500",
                            "aria-hidden": "true"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(__props.title), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(__props.subtitle), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: close,
                        class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
                      }, [
                        _hoisted_12,
                        _createVNode(_component_XMarkIcon, {
                          class: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})